import { render, staticRenderFns } from "./EditImages.vue?vue&type=template&id=6ef4e772&scoped=true"
import script from "./EditImages.vue?vue&type=script&lang=js"
export * from "./EditImages.vue?vue&type=script&lang=js"
import style0 from "./EditImages.vue?vue&type=style&index=0&id=6ef4e772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef4e772",
  null
  
)

export default component.exports